import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

type HeaderSlot = RouteSlotInput<
  typeof KitchenSinkRoute,
  'header',
  'LocationHeader'
>;
type HeaderSlotInput = Exclude<HeaderSlot['input'], Function>;

export const mapBreadcrumbs = (
  items: Array<BreadcrumbItemFragment> = [],
): Pick<HeaderSlotInput, 'breadcrumbItems' | 'HomeLink'> => {
  return {
    breadcrumbItems: items
      .filter((item, i) => !(i === 0 && item.url === '/'))
      .map((item) => ({
        title: item.text,
        Link: buildLink({ href: item.url }),
      })),
    HomeLink: buildLink({ href: '/' }),
  };
};
